<template>
  <div class="boHome" :data-search="searchList.length" :data-clickActive="clientSelect">

<!--    <div class="boHeader">-->

<!--      <div class="l">-->
<!--        <div class="logo">-->
<!--          <svg viewBox="0 0 139 95" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="w-10 mr-4 fill-current text-primary"><defs><linearGradient x1="100%" y1="10.5120544%" x2="50%" y2="89.4879456%" id="linearGradient-1"><stop stop-color="#000000" offset="0%"></stop><stop stop-color="#FFFFFF" offset="100%"></stop></linearGradient><linearGradient x1="64.0437835%" y1="46.3276743%" x2="37.373316%" y2="100%" id="linearGradient-2"><stop stop-color="#EEEEEE" stop-opacity="0" offset="0%"></stop><stop stop-color="#FFFFFF" offset="100%"></stop></linearGradient></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Artboard" transform="translate(-400.000000, -178.000000)"><g id="Group" transform="translate(400.000000, 178.000000)"><path d="M-5.68434189e-14,2.84217094e-14 L39.1816085,2.84217094e-14 L69.3453773,32.2519224 L101.428699,2.84217094e-14 L138.784583,2.84217094e-14 L138.784199,29.8015838 C137.958931,37.3510206 135.784352,42.5567762 132.260463,45.4188507 C128.736573,48.2809251 112.33867,64.5239941 83.0667527,94.1480575 L56.2750821,94.1480575 L6.71554594,44.4188507 C2.46876683,39.9813776 0.345377275,35.1089553 0.345377275,29.8015838 C0.345377275,24.4942122 0.230251516,14.560351 -5.68434189e-14,2.84217094e-14 Z" id="Path" class="text-primary fill-current"></path><path d="M69.3453773,32.2519224 L101.428699,1.42108547e-14 L138.784583,1.42108547e-14 L138.784199,29.8015838 C137.958931,37.3510206 135.784352,42.5567762 132.260463,45.4188507 C128.736573,48.2809251 112.33867,64.5239941 83.0667527,94.1480575 L56.2750821,94.1480575 L32.8435758,70.5039241 L69.3453773,32.2519224 Z" id="Path" fill="url(#linearGradient-1)" opacity="0.2"></path><polygon id="Path-2" fill="#000000" opacity="0.049999997" points="69.3922914 32.4202615 32.8435758 70.5039241 54.0490008 16.1851325"></polygon><polygon id="Path-2" fill="#000000" opacity="0.099999994" points="69.3922914 32.4202615 32.8435758 70.5039241 58.3683556 20.7402338"></polygon><polygon id="Path-3" fill="url(#linearGradient-2)" opacity="0.099999994" points="101.428699 0 83.0667527 94.1480575 130.378721 47.0740288"></polygon></g></g></g></svg>-->
<!--          Statum Poker-->
<!--        </div>-->

<!--        <div class="casino">-->
<!--          <div class="ico">-->
<!--            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="18" height="18" viewBox="0 0 24 24"><path d="M12,18H6V14H12M21,14V12L20,7H4L3,12V14H4V20H14V14H18V20H20V14M20,4H4V6H20V4Z" /></svg>-->
<!--          </div>-->
<!--          {{ casino.name }}</div>-->
<!--      </div>-->

<!--    </div>-->

    <div class="colGrp">

      <div class="col">
        <!--        <h1>-->
        <!--          Rechercher un joueur-->
        <!--        </h1>-->

        <h1>Inscription Poker Cash Game</h1>

        <p>Pour inscrire un joueur, recherchez son nom et prenom</p>

        <div class="phoneInfo">
          <svg width="30" height="30" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M16 22.621l-3.521-6.795c-.007.004-1.974.97-2.064 1.011-2.24 1.086-6.799-7.82-4.609-8.994l2.082-1.026-3.492-6.817-2.106 1.039c-1.622.845-2.298 2.627-2.289 4.843.027 6.902 6.711 18.013 12.212 18.117.575.011 1.137-.098 1.677-.345.121-.055 2.102-1.029 2.11-1.033zm4-5.621h-1v-13h1v13zm-2-2h-1v-9h1v9zm4-1h-1v-7h1v7zm-6-1h-1v-5h1v5zm-2-1h-1v-3h1v3zm10 0h-1v-3h1v3zm-12-1h-1v-1h1v1z"/></svg>
          <div class="txt">
            <div class="title">Informer chaque joueur</div>
            <div class="desc">Votre place est garantie 15 minutes après l'heure de la réservation</div>
          </div>
        </div>

        <form action="" @submit.prevent="startSearch" class="searchMain">
          <!--          <label>Recherche dans la base Players+</label>-->
          <input type="text" ref="search" v-model="query" placeholder="Nom et prénom" autofocus>

          <div class="formLoader">
            <div v-if="clientSelect" class="formClose" @click="resetSearch">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M23 20.168l-8.185-8.187 8.185-8.174-2.832-2.807-8.182 8.179-8.176-8.179-2.81 2.81 8.186 8.196-8.186 8.184 2.81 2.81 8.203-8.192 8.18 8.192z"/></svg>
            </div>
            <svg v-else-if="formLoaderEtat" class="l" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm8 12c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-19 0c0-6.065 4.935-11 11-11v2c-4.962 0-9 4.038-9 9 0 2.481 1.009 4.731 2.639 6.361l-1.414 1.414.015.014c-2-1.994-3.24-4.749-3.24-7.789z"/></svg>
            <svg v-else class="pplus" data-v-470cc224="" width="120" height="35" viewBox="0 0 219 80" xmlns="http://www.w3.org/2000/svg"><g data-v-470cc224="" fill-rule="evenodd"><path data-v-470cc224="" d="M11.83 7.58C4.95 8.46-.35 13.93.02 23.46v55.93L6 77.09V19.23c0-4.4 1.59-7.59 5.82-11.64"></path><path data-v-470cc224="" d="M21.22 5.36c-6.88.91-12.17 6.55-11.82 16.35v57.57l6-2.36V17.35c0-4.54 1.59-7.8 5.82-11.99"></path><path data-v-470cc224="" d="M30.84 3c-6.88.94-12.17 6.74-11.82 16.85v59.34l6-2.43v-61.4c0-4.68 1.15-9.14 5.82-12.36M34.83 2.22A8.82 8.82 0 0147.34 9.7v25.5c0 4.24-4.58 10.94-15.35 10.77 8.83-3.89 9.53-8.83 9.7-15.53V8.7c0-7.69-5.64-6.3-6.88-6.48M52.53 46.82h165.95v-1.38H52.53zM169.05 54.44h-2.94v22.04h14.03v-2.75h-11.1zM196.85 71.91s.06 1.68-1.85 1.68H187s-1.71-.2-1.71-2.27V54.44h-2.94v17.47h.02c0 4.65 4.57 4.57 4.57 4.57s4.07-.06 8.62 0c4.48.05 4.21-4.38 4.21-4.38V54.44h-2.93v17.47zM33.2 54.44h-2.93v22.04H44.3v-2.75H33.2c-.42 0 0-19.29 0-19.29M50.8 69.17l4.36-11.83 4.36 11.83H50.8zm4.36-14.73h-2.05l-7.96 21.88h3.01l1.61-4.37h10.78l1.6 4.37h3.02l-7.96-21.88h-2.05zM71.63 64.1l-6.07-9.66H62l8 12.68v9.2h3.25v-9.2l8-12.68H77.7zM82.64 76.32h14.27V73.7H85.62v-7.22h10.86v-2.4H85.62v-7h11.29v-2.63H82.64zM112.9 63.15s-.2 1.93-2.27 1.93h-9v-8h9s2.27 0 2.27 1.87v4.2zm2.89.06s-.06 0 0-4.55c.05-4.48-4.37-4.22-4.37-4.22H98.65v21.88h2.98v-8.54h8.31c.7.02 2.75.28 2.75 2.94v5.6h2.87v-6.94s0-2.85-2.37-2.85c2.8 0 2.6-3.32 2.6-3.32zM160.76 63.15s-.2 1.93-2.27 1.93h-9v-8h9s2.27 0 2.27 1.87v4.2zm-1.48-8.7H146.5v21.87h2.98v-8.54h9.3c.01.02.02.02.02 0h.28c4.64 0 4.56-4.57 4.56-4.57s-.06 0 0-4.55c.06-4.48-4.37-4.22-4.37-4.22zM129.99 54.2h-6.78s-5.15 0-5.15 4.13v4s.06 3.33 3.74 3.84l-.01.04.5.04.06.01h.12l6.78.57s2.18.12 2.18 1.85v3.23s.07 1.73-2.3 1.73h-5.8s-2.18.23-2.1-1.4l.03-2.49h-3.2v2.11s-.33 4.18 4.34 4.46h6.78s5.15 0 5.15-4.12v-4s-.2-3.9-4.46-4.12l-6.73-.38s-2.18-.12-2.18-1.85v-3.23s-.08-1.73 2.3-1.73h5.8s2.18-.23 2.1 1.4l-.03 2.48h3.2v-2.1s.33-4.18-4.34-4.46M214.19 64.08l-6.74-.38s-2.18-.12-2.18-1.85v-3.23s-.07-1.73 2.3-1.73h5.8s2.18-.23 2.1 1.4l-.03 2.48h3.2v-2.1s.34-4.18-4.33-4.46h-6.79s-5.15 0-5.15 4.12v4s.07 3.33 3.75 3.84l-.02.04.5.04.06.01h.13l6.78.57s2.18.12 2.18 1.85v3.23s.07 1.73-2.3 1.73h-5.8s-2.18.23-2.11-1.4l.04-2.49h-3.2v2.11s-.34 4.18 4.33 4.46h6.79s5.15 0 5.15-4.12v-4s-.2-3.9-4.47-4.12M85.54 39.84l71.21-38.22a4.76 4.76 0 016.57 1.94l6.94 13-25.08 13.38-.78 6.4 28.37-14.74L183 41H84c.39-.39.96-.78 1.54-1.16z"></path></g></svg>
          </div>
        </form>

        <div class="linkManu" @click="popAddMAnualyOpen">Ou inscrire manuellement</div>

        <div class="empty" v-if="searchEtat && !Object.keys(searchList).length">
          Pas de résultats
          <form action="" @submit.prevent="startSearchDetails">
            <div class="input">
              <label>Nom</label>
              <input type="text" placeholder="Nom" v-model="searchName">
            </div>
            <div class="input">
              <label>Prénom</label>
              <input type="text" placeholder="Prénom" v-model="searchFirstName">
            </div>
            <input type="submit" class="submit" value="Rechercher">
          </form>
        </div>

        <div class="list searchList">
          <div class="elem" v-for="n in searchList" :key="n['CLIENT_ID']" @click="clientSelect = n" :data-active="clientSelect === n">
            <div class="left">
              <div class="t">
                <div class="title">{{ n['SEX'] }} {{ n['NAME'] }} {{ n['FIRSTNAME'].split(' ')[0] }}</div>
                <div class="pres">
                  <template v-if="'TEL' in n && n['TEL'] && n['TEL'].length > 0">
                    {{ formatTel(n['TEL']) }}
                  </template>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z"/></svg>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="col">
<!--        <h1>Créneaux disponibles</h1>-->
        <transition name="slide-fade">
          <listCreneauxBO v-if="creneaux" @clickCreneau="clickCreneau" @sync="syncCreneaux" :creneaux="creneaux" :creneauxApi="creneauxApi" :clientSelect="clientSelect"></listCreneauxBO>
        </transition>
        
                
      </div>
    </div>

    <div class="notifCanPlace" v-if="clientSelect">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 16.67l2.829 2.83 9.175-9.339 9.167 9.339 2.829-2.83-11.996-12.17z"/></svg>
      <div class="txt">
        Inscrivez le joueur sur un créneau <span @click="resetSearch">Terminer</span>
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 16.67l2.829 2.83 9.175-9.339 9.167 9.339 2.829-2.83-11.996-12.17z"/></svg>
    </div>


    <pop title="Inscrire manuellement" v-if="popAddManualyEtat" @close="popAddManualyEtat = false">
      <form action="" @submit.prevent="popAddManualySubmit">
        <div class="int">
          <div class="input">
            <label>Nom</label>
            <input type="text" ref="inputFocus" v-model="popAddManualyName">
          </div>
          <div class="input">
            <label>Prénom</label>
            <input type="text" v-model="popAddManualyFirstName">
          </div>
          <div class="input">
            <label>Numéro de télephone</label>
            <vue-tel-input v-model="popAddManualyPhone" :inputOptions="{ placeholder: 'Numéro de télephone', autofocus: true }" defaultCountry="FR" @validate="phone_validate_method"></vue-tel-input>
          </div>
        </div>
  
        <div class="submitBlock">
          <input type="submit" class="submit" value="Inscrire">
        </div>
      </form>
      
      
    </pop>
    
    
    
    
    
  </div>
</template>

<script>
import listCreneauxBO from "@/components/poker/listCreneaux";
export default {
  name: "Home",
  data() {
    return {
      query: null,
      searchFirstName: null,
      searchName: null,
      searchEtat: false,

      casino: {},
      creneaux: null,
      creneauxApi: null,

      searchList: {},

      clientSelect: null,

      formLoaderEtat: false,
      
      popAddManualyEtat: false,
      popAddManualyName: null,
      popAddManualyFirstName: null,
      popAddManualyPhone: null,
      phone_validate: null,
      
      
      manualyEtat: false
      
      
    }
  },
  components: { listCreneauxBO },
  created() {
    let _this = this
    this.syncCreneaux()
    
    setInterval(() => {
      _this.syncCreneaux()
    }, 30000)
  },
  mounted() {
    this.$refs.search.focus()
  },
  methods: {
    startSearch() {
      this.clientSelect = null
      this.manualyEtat = false
      if(this.query === '' || !this.query || this.query.length < 3) {
        this.resetSearch()
      }
      else {
        this.searchEtat = false
        this.formLoaderEtat = true
        // let query = this.query.replace(' ', ',')
        let splitQuery = this.query.split(' ')

        let query

        if(splitQuery.length > 1) {
          this.searchFirstName = splitQuery.pop()
          this.searchName = splitQuery.join(' ')
          query = this.searchFirstName + ',' + this.searchName
        }
        else {
          this.searchName = splitQuery
          this.searchFirstName = null
          query = this.searchName
        }


        this.$httpStatum.get('/ptech/search/' + query).then((data) => {
          this.searchEtat = true
          this.searchList = data.data
          this.formLoaderEtat = false
        })
      }
    },
    startSearchDetails() {
      this.clientSelect = null
      this.manualyEtat = false
      if(this.searchFirstName.length >= 3 && this.searchName.length >= 3) {
        this.searchEtat = false
        this.formLoaderEtat = true
        this.$httpStatum.get('/ptech/search/' + this.searchFirstName + ',' + this.searchName).then((data) => {
          this.searchEtat = true
          this.searchList = data.data
          this.formLoaderEtat = false
        })
      }
    },
    resetSearch() {
      this.query = null
      this.searchFirstName = null
      this.searchName = null
      this.clientSelect = null;
      this.searchEtat = false;
      this.searchList = {}
      this.manualyEtat = false
    },
    syncCreneaux() {
      this.$httpStatum.get('/poker/bo/list').then((data) => {
        this.creneauxApi = data.data.data
        this.creneaux = data.data.creneaux
        this.casino = data.data.casino
      })
    },
    clickCreneau(data) {

      if(this.manualyEtat) {
        if(this.clientSelect) {
          this.$httpStatum.post('/poker/bo/bookmanualy', {
            clientData: this.clientSelect,
            creneau: data.creneau
          }).then(() => {
            if(this.clientSelect['TEL'])
              this.$notyf.success(`Client inscrit le ${ this.$dayjs(data.creneau, 'DD/MM/YYYY HH:mm:ss').format('dddd DD à HH:mm') }<br> SMS Envoyé`)
            else
              this.$notyf.success(`Client inscrit le ${ this.$dayjs(data.creneau, 'DD/MM/YYYY HH:mm:ss').format('dddd DD à HH:mm') }`)
            
            this.syncCreneaux()
          }).catch(() => {
            this.$notyf.error('Le client est déjà inscrit sur ce créneau')
          })
        }
      }
      else {
        if(this.clientSelect && this.clientSelect['CLIENTID']) {
          this.$httpStatum.post('/poker/bo/book', {
            clientId: this.clientSelect['CLIENTID'],
            clientData: this.clientSelect,
            creneau: data.creneau
          }).then(() => {
            if(this.clientSelect['TEL'])
              this.$notyf.success(`Client inscrit le ${ this.$dayjs(data.creneau, 'DD/MM/YYYY HH:mm:ss').format('dddd DD à HH:mm') }<br> SMS Envoyé`)
            else
              this.$notyf.success(`Client inscrit le ${ this.$dayjs(data.creneau, 'DD/MM/YYYY HH:mm:ss').format('dddd DD à HH:mm') }`)
            
            this.syncCreneaux()
            // this.$notyf.success('Client inscrit le ' + this.$dayjs(data.creneau, 'DD/MM/YYYY HH:mm:ss').format('dddd DD à HH:mm'))
          }).catch(() => {
            this.$notyf.error('Le client est déjà inscrit sur ce créneau')
          })
        }
      }
      
      
      
    },
    formatTel(phone) {
      if(phone && this.$phoneNumber(phone))
        return this.$phoneNumber(phone).formatNational()
    },
    phone_validate_method(data) {
      this.phone_validate = data
    },
    popAddMAnualyOpen() {
      this.popAddManualyEtat = true
      this.popAddManualyName = null
      this.popAddManualyFirstName = null
      this.popAddManualyPhone = null
      this.$nextTick(() => {
        this.$refs.inputFocus.focus()
      })
    },
    popAddManualySubmit() {
      if (this.phone_validate && this.phone_validate.valid === true) {
        
        let r = {
          "TEL": this.phone_validate.number,
          "NAME": this.popAddManualyName.toUpperCase(),
          "FIRSTNAME": this.popAddManualyFirstName.toUpperCase()
        }
        
        this.query = this.popAddManualyName.toUpperCase() + ' ' + this.popAddManualyFirstName.toUpperCase()
        
        this.clientSelect = r
        this.popAddManualyEtat = false
        
        this.manualyEtat = true
        
        // this.etape = 1
        // axios.post('/checksms/create', { phoneNumber: this.phone_validate.number })
        // this.buttonActive = false
      }
    },
  }
}
</script>

<style>
/*.boHome .colGrp .col:nth-child(2) .list .elem { background: #f8f9fd; border-bottom-color: #f1f2fb; border-radius: 6px; margin-bottom: 6px; }*/
/*.boHome .colGrp .col:nth-child(2) .list .elem { background: #1fbfd4; color: #fff; }*/
/*.boHome .colGrp .col:nth-child(2) .list .elem .img { background: none; fill: #7d7f8f }*/
/*.boHome .colGrp .col:nth-child(2) .list .elem .btn { background: #fff; box-shadow: 0 4px 15px rgb(225, 227, 236) }*/
/*.boHome .colGrp .col:nth-child(2) h4 { padding-left: 0; }*/
</style>

<style scoped>

/*.boHeader .l .casino { height: 60%; background: #f4f3f6; display: flex; align-items: center; padding: 0 18px 0 12px; border-radius: 4px }*/
/*.boHeader .l .casino .ico { background: #f6e4e4; fill: #e27b54; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; border-radius: 100%; margin-right: 10px; }*/


.notifCanPlace { position: fixed; bottom: 0; width: 34%; right: 0px; background: #d2302a; height: 60px; display: flex; align-items: center; justify-content: space-around; color: #fff; fill: #fff; padding: 0 30px; animation: notifCanPlace .1s ease }
.notifCanPlace .txt { display: flex; align-items: center }
.notifCanPlace span { border: 1px solid rgba(255,255,255,.4); padding: 6px 12px; border-radius: 60px; margin-left: 12px; cursor: pointer }

@keyframes notifCanPlace {
  0% { transform: translateY(20px); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
}


.fill-current {
  fill: #75b80d;
}


.boHome { height: calc(100vh - 73px); overflow-y: auto }

.colGrp { display: flex; }
.colGrp .col { width: 34%; padding-bottom: 150px;  }


.colGrp .col:nth-child(1) {  width: 66%; display: flex; flex-direction: column; justify-content: flex-start; padding: 40px 14% }

.boHome[data-search] .colGrp .col:nth-child(1) { justify-content: flex-start; }

.colGrp .col:nth-child(1) h1 { font-size: 30px; margin-bottom: 0px; }

.colGrp .col:nth-child(2) { position: relative; padding: 40px 40px 150px 40px; background: #fff; border-left: 1px solid #f1f2fb; transition: all .2s ease; height: calc(100vh - 73px); overflow-y: auto; }


/*.boHome[data-clickActive] .colGrp .col:nth-child(1) { display: none }*/
/*.boHome[data-clickActive] .colGrp .col:nth-child(2) { left: 50%; transform: translateX(-50%) }*/
/*.boHome[data-clickActive] .colGrp .col:nth-child(2) { border-left: 4px solid #d2302a; border-right: 4px solid #d2302a;  }*/


form.searchMain { background: #fff; display: flex; flex-direction: column; position: relative; margin-top: 26px; margin-bottom: 12px; border: 3px solid #f1f2f6; border-bottom: 3px solid #d2302a;  border-radius: 6px }
form.searchMain input { border: 0; height: 70px; padding: 0 30px; font-size: 22px; color: #111 }
form.searchMain .formLoader { position: absolute; top: 0; right: 0; bottom: 0; display: flex; align-items: center; }
form.searchMain .formLoader .l { fill: #7D7F8F; animation: rotate 1.5s infinite linear; margin-right:  26px; }
form.searchMain .formLoader .pplus { padding-right: 16px; fill: #d2302a; }
form.searchMain .formClose { width: 80px; height: 70px; display: flex; align-items: center; justify-content: center; opacity: .6; cursor: pointer }

.linkManu { text-decoration: underline; text-align: right; margin-bottom: 24px; cursor: pointer }

.empty { background: #fff; padding: 0 10px; display: flex; flex-direction: column; padding: 34px; text-align: center }
.empty form { display: flex; justify-content: center; margin-top: 34px; }
.empty form .input { margin-right: 10px; margin-top: 0; }
.empty form .submit { height: 50px; }



/*.list .elem { background: #fff; border-bottom-color: #f1f2fb; cursor: pointer }*/


.list { }
.list .elem { padding: 14px 18px; display: flex; background: #fff; align-items: center; justify-content: space-between; border-bottom: 1px solid #f1f2fb; cursor: pointer }
.list .elem .left { display: flex; align-items: center }
.list .elem .img { width: 60px; height: 60px; background: rgba(0,0,0,.1); fill: #EFEFF0; border-radius: 50%; margin-right: 20px; overflow: hidden; position: relative;
  display: flex; align-items: center; justify-content: center; padding: 3px }
.list .elem .img img { height: 100%; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) }
.list .elem .t .title { font-size: 17px; font-weight: 500; margin-bottom: 4px; }
.list .elem .t .pres { font-size: 14px; color: #7D7F8F; fill: #7D7F8F; display: flex; align-items: center }
.list .elem .t .pres svg { margin-right: 4px; }
.list .elem .right { color: #7D7F8F; font-size: 14px; font-weight: 400; }

.list .elem[data-empty] { opacity: .4; }


.list .elem .btn { background: none; border: 1px solid #f1f2fb; padding: 0; width: 48px; height: 48px; display: flex; align-items: center; justify-content: center;
  border-radius: 50%;
}
.list .elem:hover { background: #f1f2fb; }
.list .elem:hover .btn { background-color: #fff; }

.list .elem[data-active] { background: #d2302a; color: #fff; }
.list .elem[data-active] .pres { color: #fff; }
.list .elem[data-active] .btn { border-color: #fff; fill: #fff; background: none; }

.searchList { max-height: calc(100vh - 476px); overflow-y: auto }


.phoneInfo { display: flex; align-items: center; background: #fff; padding: 14px 26px; fill: #d2302a; margin-top: 6px; }
.phoneInfo .txt { margin-left: 16px; font-size: 18px }
.phoneInfo .txt .title { font-weight: bold; font-size: 20px; color: #d2302a }


*::-webkit-scrollbar {
  width: 6px;
}

*::-webkit-scrollbar-track {
  background: #fff;
}

*::-webkit-scrollbar-thumb {
  background-color: #f1f2f6;
}

p { font-size: 18px; color: #7d7f8f; margin-top: 4px; }

h1 { font-size: 28px; font-weight: bold; text-transform: uppercase; }
h1 .pplus { position: absolute; right: 0px; top: 0px; fill: #ffa200 }

@keyframes rotate {
  0% { transform: rotate(0) }
  100% { transform: rotate(360deg) }
}

</style>